import { GET_BUS_USER_CONFIG } from '../actions/getBusUserConfig';
import { LOGOUT_ACTION } from 'modules/general/shared/action/logout';
import { SET_USER_BUS_PROVIDER } from '../actions/setUserBusProvider';

const initialState = {
  initialized: false,
  userPermission: {
    bookingInAdvance: false,
    goShow: false,
  },
};

export default function busUserConfigReducer(state = initialState, action) {
  switch (action.type) {
    case GET_BUS_USER_CONFIG:
      return { ...action.payload, initialized: true };
    case SET_USER_BUS_PROVIDER:
      return { ...state, providerId: action.payload };
    case LOGOUT_ACTION:
      return initialState;
    default:
      return state;
  }
}
